import { WorkflowStatusName, WorkflowOperation } from "../items";

// ワークフローフェーズ参照用model
export class WorkflowPhaseReference {
  public id: string;
  public correspondStatus: WorkflowStatusName;
  public limitDate: Date;
  public isCurrentPhase: boolean;
  public operations: WorkflowOperation[];
}
